import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';
import { Fabric } from '../../models/fabric/fabric';
import { CommandSearchFabric } from '../../models/fabric/fabric-seach';

@Injectable({
  providedIn: 'root',
})
export class FabricProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/fabric';

  public getAllFabrics(): Observable<ApiResponse<Fabric[]>> {
    return this.httpClient.get<ApiResponse<Fabric[]>>(`${this.baseUrl}/all`);
  }

  public getFabricById(id: string): Observable<ApiResponse<Fabric>> {
    return this.httpClient.get<ApiResponse<Fabric>>(`${this.baseUrl}/${id}`);
  }

  public createFabric(fabric: Fabric): Observable<ApiResponse<Fabric>> {
    return this.httpClient.post<ApiResponse<Fabric>>(this.baseUrl, fabric);
  }

  public batchGetFabricsByCodes(fabricCodes: string[]): Observable<ApiResponse<Fabric[]>> {
    return this.httpClient.post<ApiResponse<Fabric[]>>(`${this.baseUrl}/fabric-code/batch`, fabricCodes);
  }

  public search(
    searchCommand: CommandSearchFabric,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder?: number,
  ): Observable<ApiResponse<PaginatedApiResponse<Fabric>>> {
    let url = `${this.baseUrl}/search?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (sortField) {
      url += `&sortField=${sortField}&sortOrder=${sortOrder ?? -1}`;
    }
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<Fabric>>>(url, searchCommand);
  }

  public updateFabric(id: string, fabric: Fabric): Observable<ApiResponse<Fabric>> {
    return this.httpClient.put<ApiResponse<Fabric>>(`${this.baseUrl}/${id}`, fabric);
  }
}
